export enum GroupTypeDescriptionEnum {
  PERSONALNA = 'groups.groupType.personal',
  STRUKTURALNA = 'groups.groupType.structural',
}
